import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { canViewReports, checkHOD, checkHOU } from '../../permission-utils/settings';
import { useSelector } from 'react-redux';

const StoreMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);
	const staff = useSelector(state => state.user.profile);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{(isSupervisor || canViewReports(staff, 'inventory-audit')) && (
				<li>
					<Link to="/store/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}

			<li>
				<Link to="/store">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Inventory</span>
				</Link>
			</li>
			<li>
				<Link to="/store/vendors">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Vendors</span>
				</Link>
			</li>
			<li>
				<Link to="/store/categories">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Categories</span>
				</Link>
			</li>
			<li>
				<Link to="/store/requisitions">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Requisitions</span>
				</Link>
			</li>
			<li>
				<Link to="/store/activities">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Store Supplies</span>
				</Link>
			</li>
			<li>
				<Link to="/store/cafeteria-supplies">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Cafeteria Supplies</span>
				</Link>
			</li>
		</>
	);
};

export default StoreMenu;
